
export const selectAttendanceDashboard = (state) =>
    state.attendance.attendanceDashboard;

export const selectAttendanceList = (state) => 
    state.attendance.attendanceData;

export const selectAttendanceLoading = (state) => 
    state.attendance.loading;

export const selectAttendanceMeta = (state) =>
    state.attendance.attendanceMeta;
